import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { isFullAccess } from "src/auth/ProtectedRoutes";
import useAuth from "src/hooks/useAuth";
import Controls from "src/components/form/controls/Controls";

const SubAccessControlPanel = ({
  children,
  handleOpenPopup,
  parentRoute,
  parentRouteId,
}) => {
  const { auth } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {isFullAccess(auth?.permissions) && (
          <Controls.Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => {
              handleOpenPopup(null, parentRoute, parentRouteId);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SubAccessControlPanel;
